import React from 'react'
import { X } from 'lucide-react'
import { useTheme } from '../../components/Theme/ThemeProvider'

function DisplayImage({
    imgUrl,
    onClose,
    name
}) {
    const { colors } = useTheme()
    
    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-fadeIn'>
            <div 
                className='rounded-xl shadow-2xl max-w-3xl w-full border'
                style={{
                    backgroundColor: colors.bgSecondary,
                    borderColor: colors.border,
                    animation: 'slideUp 0.3s ease-out'
                }}
            >
                {/* Header */}
                <div 
                    className='flex items-center justify-between p-6 border-b'
                    style={{
                        borderColor: colors.border,
                        background: `linear-gradient(135deg, ${colors.primary}15 0%, ${colors.accent}15 100%)`
                    }}
                >
                    <h3 className='font-bold text-lg' style={{ color: colors.text }}>
                        Image Preview
                    </h3>
                    <button
                        onClick={onClose}
                        className='p-2 rounded-lg transition-all hover:scale-110'
                        style={{
                            backgroundColor: colors.bg,
                            color: colors.primary
                        }}
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>

                {/* Content */}
                <div className='p-6 flex flex-col items-center gap-4'>
                    <img
                        src={imgUrl}
                        alt="Product"
                        className='max-w-full max-h-[60vh] object-contain rounded-lg'
                        style={{ border: `2px solid ${colors.primary}` }}
                    />
                    <p className='text-sm font-medium' style={{ color: colors.textSecondary }}>
                        {name || 'Product Image'}
                    </p>
                </div>
            </div>

            <style jsx>{`
                @keyframes fadeIn {
                    from {
                        opacity: 0;
                    }
                    to {
                        opacity: 1;
                    }
                }
                
                @keyframes slideUp {
                    from {
                        opacity: 0;
                        transform: translateY(20px) scale(0.95);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0) scale(1);
                    }
                }
                
                .animate-fadeIn {
                    animation: fadeIn 0.2s ease-out;
                }
            `}</style>
        </div>
    )
}

export default DisplayImage;